import { render, staticRenderFns } from "./home-insurance-companies.html?vue&type=template&id=6b895bcc&scoped=true&"
import script from "./home-insurance-companies.js?vue&type=script&lang=js&"
export * from "./home-insurance-companies.js?vue&type=script&lang=js&"
import style0 from "./home-insurance-companies.scss?vue&type=style&index=0&id=6b895bcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b895bcc",
  null
  
)

export default component.exports